export default __webpack_public_path__ + "static/media/Snd1.2f534d88.mp3";